import {useContext, useEffect, useState} from 'react';
import {Notification} from './../queries/Notification';
import {NotificationListContext} from '../state/notificationListContext';
import {useKeycloak} from '@react-keycloak/web';
import useToken from '../../useToken';
import {useAuthentication} from '../../auth/hooks/useAuthentication';
import {useNotificationPush} from './useNotificationPush';

export const useNotificationList = (disableRealTime = false) => {
  const {state: notifications, dispatch} = useContext(NotificationListContext);
  const [loading, setLoading] = useState(false);
  const {keycloak, initialized} = useKeycloak();
  const {token} = useToken();
  const {isAuthenticated} = useAuthentication();

  const init = async (data = null) => {
    console.log(data, 'data');
    setLoading(true);
    try {
      const notifications = await Notification.findAll();
      const nextcloudNotification = data && {
        isPending: true,
        title:
          data.message.object_type == 'chat'
            ? 'Nouveau message'
            : 'Appel entrant',
        message:
          data.message.object_type == 'chat'
            ? 'Vous avez reçu un nouveau message'
            : 'Vous avez eu un appel entrant',
        actionUrl:
          data.message.object_type == 'chat'
            ? `${process.env.REACT_APP_NEXTCLOUD_BASE_URL}/apps/spreed/?callUser=${data.message.subject_parameters.userId}`
            : null,
      };

      if (nextcloudNotification) notifications.unshift(nextcloudNotification);

      dispatch({
        type: 'initNotifications',
        payload: notifications,
      });
    } finally {
      setLoading(false);
    }
  };

  useNotificationPush(init, disableRealTime);

  useEffect(() => notifications.length === 0 && init(), []);

  const markAllAsRead = () => {
    const ids = notifications.map(notification => notification.id);
    Notification.markAsReaded(ids).then(() =>
      dispatch({type: 'readNotitifications', payload: ids}),
    );
  };

  const markAsReaded = async id => {
    return Notification.markAsReaded([id]).then(() =>
      dispatch({type: 'readNotitifications', payload: [id]}),
    );
  };

  return {
    loading,
    notifications,
    markAllAsRead,
    markAsReaded,
    pendingCount: notifications.filter(notification => notification.isPending)
      .length,
  };
};
